import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GenericService as HipGenericService, ToolsService } from '@huge-monorepo/hip/services';
import { BaseMapLocation } from '../../interfaces/BaseMapLocation';
import { SharedToolsService } from '../../tools/tools.service';
import { BaseMapComponent } from '../../components/base-map/base-map.component';
import { MaterialModule } from '../../modules/material/material.module';
import { MapBounds } from '../../interfaces/MapBounds';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { GenericService as CustomerGenericService } from '@huge-monorepo/portal/services';
import { Routes } from '@huge-monorepo/portal/config';
import { Router } from '@angular/router';

@Component({
  selector: 'huge-monorepo-current-sim-locations',
  standalone: true,
  imports: [CommonModule, BaseMapComponent, MaterialModule, NgxSkeletonLoaderModule],
  templateUrl: './current-sim-locations.component.html',
  styleUrl: './current-sim-locations.component.scss',
})
export class CurrentSimLocationsComponent implements OnInit {
  @Input({ required: true }) simsEndpoint: (string, number?) => string;
  @Input({ required: true }) genericService: HipGenericService | CustomerGenericService;
  @Input({ required: true }) project: 'HIP' | "HICP";
  @Input({ required: false }) portalGroupID: number;
  simLocations: BaseMapLocation[] | null;
  searchText: string = '';
  distinctDeviceCount: number;
  invalidLocationCount: number = 0;
  unknownLocationCount: number = 0;
  shouldCalculateCenter: boolean = false;
  shouldClusterMarkers: boolean = true;
  connectedSimsList: string = '';

  constructor(
    private tools: ToolsService,
    private sharedTools: SharedToolsService,
    private routeDictionary: Routes,
    private router: Router,
  ) {
      window["routeUserToDeviceCallback"] = this.routeUserToDevice.bind(this);
    }

  ngOnInit(): void {
    this.getMapData();
  }

  buildConnectedSimsList(sim) {
    //Add a sim if it is associated with the current tower.
    if (sim) {
        this.connectedSimsList += `
        <li
          style="
            cursor: pointer;
            padding: 4px;
          "
          onClick="window.routeUserToDeviceCallback(${sim.DeviceID}, ${sim.KeepAliveDeviceID})">
            ${sim.SimNum} (${this.tools.FormatDateTimeFromDateSwedish(this.tools.ParseAPIDate(sim.Locations[0].Timestamp))})
        </li>`;
    }

    return this.connectedSimsList;
  }

  routeUserToDevice(deviceId, kadevice_id) {
    this.router.navigate([this.routeDictionary.CDRDeviceDetails], {
      state: {
        data: {
          CdrID: deviceId,
          KaID: kadevice_id,
        },
      },
    });
  }

  getMapData(bounds?: MapBounds) {
    if (this.searchText.length > 0) {
      this.shouldCalculateCenter = true;
      this.shouldClusterMarkers = false;
    } else {
      this.shouldCalculateCenter = false;
      this.shouldClusterMarkers = true;
    }
    this.simLocations = null;
    this.invalidLocationCount = 0;
    this.unknownLocationCount = 0;
    if (bounds == null) {
      bounds = {
        NE: {
          Lat: -25.276852085808923,
          Long: 30.172142061416416,
        },
        SW: {
          Lat: -26.95128592043803,
          Long: 26.527505342377427,
        }
      }
    }

    let ep = this.simsEndpoint(this.searchText);
    if (this.project === 'HICP') {
      ep = this.simsEndpoint(this.searchText, this.portalGroupID);
    }
    this.genericService.POST(ep, { Bounds: {}, IgnoreBounds: true }).subscribe((response) => {
      let data = this.project === 'HIP' ? response : response['body'];

      if (data['Sims'] == null) {
        this.simLocations = [];
        return;
      }

      this.distinctDeviceCount = data['DistinctDeviceCount'];

      let tempSimLocations: BaseMapLocation[] = [];
      let simsMap: Map<string, any[]> = new Map();
      let locationsMap: Map<string, any> = new Map();
      data['Sims'].forEach((sim, index1) => {
        for (let i = 0; i < sim.Locations.length; i++) {
          let location = sim.Locations[i];
          if (location.Lat == null || location.Long == null) {
            this.unknownLocationCount++;
            continue;
          }
          if (location.Lat == 0 && location.Long == 0) {
            this.invalidLocationCount++;
            continue;
          }

          let locationString = `${location.Lat}${location.Long}${location.MNC}`;

          if (simsMap.has(locationString)) {
            simsMap.get(locationString)!.push(sim);
          } else {
            simsMap.set(locationString, [sim]);
          }

          if (!locationsMap.has(locationString)) {
            locationsMap.set(locationString, location);
          }
        }
      });

      simsMap.forEach((value, key) => {
        value.forEach((sim) => {
          this.buildConnectedSimsList(sim);
        });

        let location = locationsMap.get(key)!;

        let latitude = location.Lat;
        let longitude = location.Long;
        let customIcon = this.sharedTools.GetBasicTowerMarkerInfo(location.MNC, null);
        let infoWindowContent = `
          <span>LAC: ${location.LAC}</span><br />
          <span>Cell ID: ${location.CellID}</span><br />
          <span>MCC: ${location.MCC}</span><br />
          <span>MNC: ${location.MNC}</span><br />
          <span>Provider: ${this.sharedTools.GetNetworkNameByMNC(location.MNC)}</span><br />
          <h5>Connected SIMs:</h5>
          <ul style="
            padding-left: 24px;
            scroll-behavior: smooth;
          ">
          ${this.connectedSimsList}
          </ul>
        `;

        customIcon.icon = "assets/map-markers/" + customIcon.icon;

        tempSimLocations.push({
          latitude: latitude,
          longitude: longitude,
          infoWindowContent: infoWindowContent,
          customIcon: customIcon,
        });

        this.connectedSimsList = '';
      });

      this.simLocations = tempSimLocations;
    });
  }

  keyDownEnter(event) {
    if (event.key == 'Enter' && this.searchText.length > 0) {
      this.getMapData();
    }
  }

  // mapBoundsChanged(ev: MapBounds) {
  //   this.simLocations = null;
  //   this.getMapData(ev);
  // }
}
